"use client";

import { Image } from "semantic-ui-react";

export default function ShareButton({ isMobile, handleShareButtonClick }) {
  return (
    <button className="share-button" onClick={handleShareButtonClick}>
      <Image
        style={{ height: "35px", width: "35px" }}
        src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/share_icons/sharebtn.png`}
        title="Share icon"
        alt="Share icon"
        height={35}
        width={35}
        loading="lazy"
      />
      {!isMobile && "Share this page"}
    </button>
  );
}
